import { render } from "./PartnerPage.vue?vue&type=template&id=06965902&scoped=true"
const script = {}

import "./PartnerPage.vue?vue&type=style&index=0&id=06965902&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06965902"]])

export default __exports__